<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <div class="text-xs-center">
      <SvgButtons :vistos="vistos" @openModal="modal=true, text=$event, playDialog($event), $set(vistos,$event,true)"/>
    </div>
    <modal-app v-model="modal" :blackBg="true">
      <v-layout v-if="text==0">
        <v-flex>
          <dialogos-app ref="dialogo1" :dialogos="dialogos1" :adelanteVisible="imageActive" @update:currentText="playAudioDialog1"></dialogos-app>
          <div class="svg1">
            <svg1 @click.native="imageActive = true, $refs.dialogo1.saltarAlDialogo(1), augmentViewBoxSvg1()" class="svg1" :translateX="viewBoxWidthSvg1"  :class="imageActive?'':'hvr hvr-shrink'" :width="(490+viewBoxWidthSvg1)+'px'"/>
          </div>
        </v-flex>
      </v-layout>
      <v-layout v-show="text==1">
        <v-flex>
          <dialogos-app ref="dialogo2" :dialogos="dialogos2"></dialogos-app>
          <div class="text-xs-center">
            <svg2 @mostrar="currentText=$event"/>
          </div>
          <div v-if="textModal2 != ''">
            <transition name="custom" enter-active-class="animated fadeInUp faster" leave-active-class="animated fadeOutDown faster" mode="out-in">
              <p class="texto1 mt-4" :key="textModal2">
                <span v-html="textModal2"></span>
              </p>
            </transition>
          </div>
        </v-flex>
      </v-layout>
      <v-layout v-show="text==2">
        <v-flex>
          <dialogos-app ref="dialogo3" :dialogos="dialogos3"></dialogos-app>
          <div class="text-xs-center">
            <svg3 />
          </div>
        </v-flex>
      </v-layout>
    </modal-app>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
      'Modulo 3/AUDIO 03',
      'Modulo 3/AUDIO 04',
      'Modulo 3/AUDIO 05',
      'Modulo 3/AUDIO 06',
      'Modulo 3/AUDIO 07',
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgButtons from '../../assets/Modulo 3/diapositiva-4'
import Svg1 from '../../assets/Modulo 3/diapositiva-5'
import Svg2 from '../../assets/Modulo 3/diapositiva-6'
import Svg3 from '../../assets/Modulo 3/diapositiva-7'

export default {
  components:{
    SvgButtons,
    Svg1,
    Svg2,
    Svg3
  },
  data() {
    return {
      viewBoxWidthSvg1: 0,
      dialogos: [
        "Ahora veremos los procedimientos analíticos que se llevan a cabo dentro de los métodos de estimación de las cantidades recuperables de crudo. <span class='instruccion'>Haz clic en cada icono.</span>",
      ],
      dialogos1: [
        "Este método es el más apropiado para la determinación de recursos prospectivos en la fase de exploración y contingentes en etapas de delineación del yacimiento. También podemos utilizar este método para la estimación de reservas cuando no contamos con suficiente información de yacimientos en producción. <span class='instruccion'>Haz clic en la imagen</span>",
        "Podemos decir que este método permite determinar los recursos o reservas de un yacimiento B con escasa información a partir de la información del yacimiento A, (yacimiento análogo), cuyas condiciones deben ser iguales o menores a las del yacimiento B. <span class='instruccion'>Puedes cerrar esta ventana.</span>"
      ],
      dialogos2: [
        "Estos procedimientos usan las posibilidades físicas de la roca; tales como; porosidad, permeabilidad, saturación, entre otros; y de los fluidos contenidos en ellas tales como petróleo y gas, para calcular el hidrocarburo en sitio y estimar qué porción de ese volumen será recuperado por un proyecto de desarrollo específico. <span class='instruccion'>Haz clic en las rocas.</span>"
      ],
      dialogos3: [
        "Estos procedimientos son utilizados en la etapa media o terminal del yacimiento y hacen uso de los datos de producción tales como presión, volumen y temperatura para la estimación de las reservas."
      ],
      text: 0,
      imageActive: false,
      modal: false,
      currentText: -1,
      vistos: Array(3).fill(false)
    }
  },
  computed: {
    textModal2: function() {
      switch (this.currentText){
        case 1: return "<h1 class='modal-title'>POROSIDAD:</h1><br>Se refiere a la medida de espacio que existe entre grano y grano de la roca.";
        case 2: return "<h1 class='modal-title'>PERMEABILIDAD:</h1><br> Propiedad de la roca para permitir el flujo de un fluido a través de la roca.";
        case 3: return "<h1 class='modal-title'>SATURACIÓN:</h1><br> Corresponde a la fracción del espacio poroso ocupado por un fluido.";
        default: return ""
      }
    }
  },
  methods: {
    playAudioDialog1(id){
      if(this.text == 0){
        this.$refs.audioPlayer.playAudio(id + 1)
      }
    },
    playDialog(id){
      // Play audio
      switch(id){
        case 0: this.$refs.audioPlayer.playAudio(1); break;
        case 1: this.$refs.audioPlayer.playAudio(3); break;
        default: this.$refs.audioPlayer.playAudio(4);
      }      
    },
    augmentViewBoxSvg1(){
      var self = this
      function interpolation(timestamp){
        self.viewBoxWidthSvg1 += timestamp/500
        if(self.viewBoxWidthSvg1 < 500){
          window.requestAnimationFrame(interpolation);
        }
        else{
          self.viewBoxWidthSvg1 = 500
        }
      }
      window.requestAnimationFrame(interpolation);
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    modal: function(newValue){
      if(!newValue){
        this.currentText = 0
      }
    },
    vistos: function(newValue){
      if(newValue.every(el => {return el})){
        this.$store.commit('nextShow', true)
      }
    },
    text: function(newValue){
      // Por alguna razon la variable currentText dentro de los dialogos se compartía o no actualizaba, 
      // así que hay que asegurar que siempre que se abra un nuevo modal los dialogos están en 0
      this.$refs.dialogo1.saltarAlDialogo(0)
      this.$refs.dialogo2.saltarAlDialogo(0)
      this.$refs.dialogo3.saltarAlDialogo(0)
    }
  }
}
</script>
<style lang="scss" scoped>
.svg1 {
  height: 420px;
  text-align: center;
}
</style>
